/**
 * KAN-958: настройки интерфейса своего пользователя.
 *
 *   GET   /api/v1/auth/me/ui-settings/  -> {ключ: значение}
 *   PATCH /api/v1/auth/me/ui-settings/  {ключ: значение} -> все настройки после правки
 *
 * Правка частичная: ключ из тела заменяется целиком, остальные ключи сервер сохраняет.
 */
import apiClient from './client';

export interface CrmTableUiSettings {
  /** Коды скрытых столбцов таблицы CRM (lib/crmTableColumns). */
  hidden_columns: string[];
}

export interface UiSettings {
  crm_table?: CrmTableUiSettings;
  [key: string]: unknown;
}

const URL = '/api/v1/auth/me/ui-settings/';

export const uiSettingsApi = {
  async get(): Promise<UiSettings> {
    const { data } = await apiClient.get<UiSettings>(URL);
    return data;
  },
  async patch(patch: Partial<UiSettings>): Promise<UiSettings> {
    const { data } = await apiClient.patch<UiSettings>(URL, patch);
    return data;
  },
};
